/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Unabletoretrieveoktaurl6Inputs */

const en_error_unabletoretrieveoktaurl6 = /** @type {(inputs: Error_Unabletoretrieveoktaurl6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unable to Retrieve Okta Redirect URL`)
};

/**
* | output |
* | --- |
* | "Unable to Retrieve Okta Redirect URL" |
*
* @param {Error_Unabletoretrieveoktaurl6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const error_unabletoretrieveoktaurl6 = /** @type {((inputs?: Error_Unabletoretrieveoktaurl6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Unabletoretrieveoktaurl6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_unabletoretrieveoktaurl6(inputs)
});
export { error_unabletoretrieveoktaurl6 as "error_unableToRetrieveOktaURL" }